import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React from 'react';
import PropTypes from 'prop-types';
import { ToasterActions, ToasterSelectors } from '@spm/core';
import { connect } from 'react-redux';
/**
 * Maps properties from the global store to this component's props.
 * This component is interested in the current state of toast stored within the Redux store.
 * @param {*} state the global store state
 */

var mapStateToProps = function mapStateToProps(state) {
  return {
    toast: ToasterSelectors.getToast(state)
  };
};
/**
 * Maps properties from global store reducers to this component's props.
 * This component requires reducer function to allow it to put a value in the toaster state in the global store
 * @param {function} dispatch the dispatch function
 */


export function mapDispatchToProps(dispatch) {
  return {
    fillToaster: function fillToaster(data) {
      ToasterActions.fillToaster(dispatch, data);
    }
  };
}
/**
 * This class is responsible for providing a container component to render toast notifications retrieved from the global store.
 * It acts as a wrapper to a passed React component/tree, allowing toast to be rendered as a sibling component.
 */

var Toaster = /*#__PURE__*/function (_React$Component) {
  _inherits(Toaster, _React$Component);

  var _super = _createSuper(Toaster);

  function Toaster() {
    _classCallCheck(this, Toaster);

    return _super.apply(this, arguments);
  }

  _createClass(Toaster, [{
    key: "isToastAvailable",

    /**
     * Determines if there is a toast notification available to display
     */
    value: function isToastAvailable() {
      var toast = this.props.toast;
      return toast && toast != null;
    }
    /**
     * Renders the toast notification and any React component/tree passed as children.
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          toast = _this$props.toast,
          children = _this$props.children,
          fillToaster = _this$props.fillToaster;
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.isToastAvailable() ? /*#__PURE__*/React.cloneElement(toast, {
        onDismiss: function onDismiss() {
          return fillToaster(null);
        }
      }) : null, children);
    }
  }]);

  return Toaster;
}(React.Component);
/**
 * Provides a container component to render toast notifications that are retrieved from the global store.
 * @param {Component} children The child components to be wrapped in the Toaster. It is optional.
 * @param {Component} toast A toast component retrieved from the global store. It is optional but not recommended to define explicitly.
 * @param {function} fillToaster An action to dispatch a toast component to the global store. It is mandatory.
 */


export default connect(mapStateToProps, mapDispatchToProps)(Toaster);
Toaster.defaultProps = {
  children: null,
  toast: null
};
Toaster.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  fillToaster: PropTypes.func.isRequired,
  toast: PropTypes.element
} : {};